import React from 'react';
import download from '@/utils/downloads';
import { states } from '@/constants/lifecycle';
import DownloadAction from '@/components/ribbon-actions/DownloadAction';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import DatasetAction from '../../../components/DatasetAction';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const DictionaryMarkdownActions = ({ category, code }) => {
  const state = Selectors.useDictionaryMarkdownActions({ category, code });
  const fetchData = Events.useFetchDictionaryMarkdown(category, { code });

  return (
    <>
      {state.allowRead && (<DatasetAction code={state.datasetCode} />)}
      {state.allowRefresh && (<RefreshActionMenu onClick={() => fetchData(state)} readStatus={state.readStatus} />)}
      {state.allowDownload && (
        <DownloadAction
          disabled={state.readStatus !== states.SUCCESS}
          onClick={() => download.textDownload(state.text, `${code}_dictionary.md`)}
        />
      )}
    </>
  );
};

export default DictionaryMarkdownActions;
